/* eslint-disable import/prefer-default-export */
export enum AnswerStatus {
  PARTIALLY_CORRECT = 'PARTIALLY_CORRECT',
  CORRECT = 'CORRECT',
  IN_CORRECT = 'INCORRECT',
  NOT_STARTED = 'NOT_STARTED'
}
